import React from "react";
import { PHILOSOPHY_POINTS, PHILOSOPHY_BODY } from "../mock";

const Philosophy = () => {
  return (
    <section className="relative bg-[#1b5e3a] text-white py-24 md:py-32 overflow-hidden">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-[0.06]">
        <div className="absolute -top-20 -left-20 w-96 h-96 rounded-full bg-[#c4a257] blur-3xl" />
        <div className="absolute -bottom-20 -right-20 w-96 h-96 rounded-full bg-[#c4a257] blur-3xl" />
      </div>

      <div className="relative max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="h-px w-10 bg-[#c4a257]" />
            <span className="text-[#c4a257] text-xs tracking-[0.3em] uppercase font-medium">
              Our Philosophy
            </span>
            <span className="h-px w-10 bg-[#c4a257]" />
          </div>
          <h2 className="font-serif text-[38px] md:text-[54px] leading-tight">
            Simpler, Natural,
            <br />
            <span className="italic text-[#e6c987]">Lasting Wellness</span>
          </h2>
          <p className="text-white/75 mt-6 max-w-2xl mx-auto leading-relaxed">
            At Tatva, we believe every person carries the blueprint for perfect
            health within. Our role is to remove the obstacles, restore the
            balance, and support the body in doing what it does best — heal.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-16">
          {PHILOSOPHY_POINTS.map((p) => (
            <div
              key={p.n}
              className="group relative rounded-2xl border border-white/15 bg-white/[0.04] backdrop-blur p-8 hover:bg-white/[0.08] hover:border-[#c4a257]/50 transition-all duration-500"
            >
              <span className="font-serif text-6xl text-[#c4a257]/80 leading-none">
                {p.n}
              </span>
              <div className="mt-4 h-px w-12 bg-[#c4a257]/60 group-hover:w-20 transition-all duration-500" />
              <p className="mt-5 text-white/90 leading-relaxed">{p.text}</p>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-3 gap-8 pt-10 border-t border-white/10">
          {PHILOSOPHY_BODY.map((t, i) => (
            <p
              key={i}
              className="text-white/70 text-[15px] leading-[1.8] first-letter:font-serif first-letter:text-4xl first-letter:text-[#c4a257] first-letter:mr-1 first-letter:float-left first-letter:leading-none"
            >
              {t}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Philosophy;
